import React from "react";
import "./VideoPage.css"; // Usa lo stesso CSS centralizzato

function VideoPage() {
  return (
    <div className="main-content">
      <h1 className="home-title">Video</h1>

      {/* Video 1 */}
      <div className="video-section">
        <h2 className="video-title">
          Il Silenzio rende Attraenti: 10 Abitudini Socialmente Attraenti
        </h2>

        <div className="iframe-container">
          <iframe
            src="https://www.youtube.com/embed/fHH-fwIP9k4"
            title="YouTube video player"
            allowFullScreen
          ></iframe>
        </div>

        <div className="button-container">
          <a
            href="https://www.youtube.com/channel/@FrequenzediSaggezzaStoica"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-icon youtube"
          >
            <i className="fab fa-youtube"></i>
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61571814955253"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-icon facebook"
          >
            <i className="fab fa-facebook"></i>
          </a>
          <a
            href="https://www.tiktok.com/@frequenze.di.sagg?_t=ZG-8t0SyheQS9p&_r=1"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-icon tiktok"
          >
            <i className="fab fa-tiktok"></i>
          </a>
        </div>

        <p className="description">
          Come essere irresistibilmente attraente senza dire una sola parola.
          Iscriviti e unisciti a noi nel cammino verso una vita più significativa e piena di gioia.
          <br />
          Tutti desideriamo essere attraenti, ma cosa succederebbe se ti dicessi che il silenzio può
          essere la chiave per attirare naturalmente l’attenzione? In questo video esploreremo
          10 abitudini socialmente attraenti, tutte radicate nella saggezza stoica.
        </p>
      </div>

      <hr className="separator" />

      {/* Video 2 */}
      <div className="video-section">
        <h2 className="video-title">
          10 STRATEGIE per DISARMARE il tuo NEMICO senza combatterlo
        </h2>

        <div className="iframe-container">
          <iframe
            src="https://www.youtube.com/embed/jgm33Bc0Hd4"
            title="YouTube video player"
            allowFullScreen
          ></iframe>
        </div>

        <div className="button-container">
          <a
            href="https://www.youtube.com/@FrequenzediSaggezzaStoica"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-icon youtube"
          >
            <i className="fab fa-youtube"></i>
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61571814955253"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-icon facebook"
          >
            <i className="fab fa-facebook"></i>
          </a>
          <a
            href="https://www.tiktok.com/@frequenze.di.sagg?_t=ZG-8t0SyheQS9p&_r=1"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-icon tiktok"
          >
            <i className="fab fa-tiktok"></i>
          </a>
        </div>

        <p className="description">
          Scopri 10 potenti strategie stoiche per neutralizzare i conflitti senza cedere alla rabbia
          o alla violenza. Impara a mantenere la tua pace interiore mentre affronti i tuoi nemici.
        </p>
      </div>

      <hr className="separator" />

      {/* Video 3 */}
      <div className="video-section">
        <h2 className="video-title">
          Il Terzo Occhio: Come Attivare e Usare la Ghiandola Pineale per Trasformare la Tua Vita
        </h2>

        <div className="iframe-container">
          <iframe
            src="https://www.youtube.com/embed/NuzBl2to2-Y"
            title="YouTube video player"
            allowFullScreen
          ></iframe>
        </div>

        <div className="button-container">
          <a
            href="https://www.youtube.com/@FrequenzediSaggezzaStoica"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-icon youtube"
          >
            <i className="fab fa-youtube"></i>
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61571814955253"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-icon facebook"
          >
            <i className="fab fa-facebook"></i>
          </a>
          <a
            href="https://www.tiktok.com/@frequenze.di.sagg?_t=ZG-8t0SyheQS9p&_r=1"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-icon tiktok"
          >
            <i className="fab fa-tiktok"></i>
          </a>
        </div>

        <p className="description">
          Scopri come attivare il terzo occhio e liberare il tuo potenziale interiore. Tecniche per
          decalcificare la ghiandola pineale, meditazione e visualizzazione per una vita più
          consapevole e spirituale.
        </p>
      </div>

      <hr className="separator" />

      {/* Video 4 */}
      <div className="video-section">
        <h2 className="video-title">
        Superare la Paura con la Saggezza Stoica: 4 Passi per Vivere Senza Paura
        </h2>

        <div className="iframe-container">
          <iframe
            src="https://www.youtube.com/embed/CkWXOihD0Vw"
            title="YouTube video player"
            allowFullScreen
          ></iframe>
        </div>

        <div className="button-container">
          <a
            href="https://www.youtube.com/@FrequenzediSaggezzaStoica"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-icon youtube"
          >
            <i className="fab fa-youtube"></i>
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61571814955253"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-icon facebook"
          >
            <i className="fab fa-facebook"></i>
          </a>
          <a
            href="https://www.tiktok.com/@frequenze.di.sagg?_t=ZG-8t0SyheQS9p&_r=1"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-icon tiktok"
          >
            <i className="fab fa-tiktok"></i>
          </a>
        </div>

        <p className="description">
        Superare la Paura con la Saggezza Stoica: 4 Passi per Vivere Senza Paura
        La paura è una delle emozioni più potenti che condiziona la nostra vita, 
        ma grazie alla saggezza stoica possiamo imparare a dominarla.
        </p>
      </div>
      
      <hr className="separator" />

      {/* Video 5 */}
      <div className="video-section">
        <h2 className="video-title">
        4 Passi per Catturare e Mantenere l’Attenzione: Lezioni dalla Saggezza Stoica
        </h2>

        <div className="iframe-container">
          <iframe
            src="https://www.youtube.com/embed/o6FXL3ZsbpU"
            title="YouTube video player"
            allowFullScreen
          ></iframe>
        </div>

        <div className="button-container">
          <a
            href="https://www.youtube.com/@FrequenzediSaggezzaStoica"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-icon youtube"
          >
            <i className="fab fa-youtube"></i>
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61571814955253"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-icon facebook"
          >
            <i className="fab fa-facebook"></i>
          </a>
          <a
            href="https://www.tiktok.com/@frequenze.di.sagg?_t=ZG-8t0SyheQS9p&_r=1"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-icon tiktok"
          >
            <i className="fab fa-tiktok"></i>
          </a>
        </div>

        <p className="description">
        I 4 passi essenziali per catturare e mantenere alta l’attenzione di chi ti ascolta, 
        ispirati alla saggezza stoica! In questo video, esploreremo come applicare i principi 
        di Seneca, Marco Aurelio, ed Epitteto per migliorare la tua comunicazione e trasformare 
        ogni parola in un messaggio potente e memorabile.
        </p>
      </div>
      
      <hr className="separator" />

      {/* Video 6 */}
      <div className="video-section">
        <h2 className="video-title">
        Racconti Zen per Ritrovare l’Equilibrio
        </h2>

        <div className="iframe-container">
          <iframe
            src="https://www.youtube.com/embed/-1VnClSkXzY"
            title="YouTube video player"
            allowFullScreen
          ></iframe>
        </div>

        <div className="button-container">
          <a
            href="https://www.youtube.com/@FrequenzediSaggezzaStoica"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-icon youtube"
          >
            <i className="fab fa-youtube"></i>
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61571814955253"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-icon facebook"
          >
            <i className="fab fa-facebook"></i>
          </a>
          <a
            href="https://www.tiktok.com/@frequenze.di.sagg?_t=ZG-8t0SyheQS9p&_r=1"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-icon tiktok"
          >
            <i className="fab fa-tiktok"></i>
          </a>
        </div>

        <p className="description">
        Racconti Zen per Ritrovare l’Equilibrio: Quando la Vita Sembra Essere Contro di Te
        Se ti trovi in una di queste situazioni, le storie zen possono fare la differenza.
        Le storie zen sono brevi racconti che trasmettono lezioni di vita profonde attraverso 
        la semplicità. Questi racconti non solo ispirano, ma aiutano a vedere le cose da una 
        nuova prospettiva, donando pace e consapevolezza.
        </p>
      </div>

      <hr className="separator" />

      {/* Video 7 */}
      <div className="video-section">
        <h2 className="video-title">
        La Felicità: L’Arte di Accettarsi e Vivere Liberi
        </h2>

        <div className="iframe-container">
          <iframe
            src="https://www.youtube.com/embed/ESqZk7Fai7o"
            title="YouTube video player"
            allowFullScreen
          ></iframe>
        </div>

        <div className="button-container">
          <a
            href="https://www.youtube.com/@FrequenzediSaggezzaStoica"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-icon youtube"
          >
            <i className="fab fa-youtube"></i>
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61571814955253"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-icon facebook"
          >
            <i className="fab fa-facebook"></i>
          </a>
          <a
            href="https://www.tiktok.com/@frequenze.di.sagg?_t=ZG-8t0SyheQS9p&_r=1"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-icon tiktok"
          >
            <i className="fab fa-tiktok"></i>
          </a>
        </div>

        <p className="description">
        La Felicità: L’Arte di Accettarsi e Vivere Liberi
        L’importanza di riconoscere il valore della libertà e dell’unicità personale.
        Hai mai sentito il peso del confronto con gli altri, pensando che la felicità 
        sia sempre altrove? Questa storia ti rivelerà una verità profonda: la felicità 
        è più vicina di quanto immagini.
        </p>
      </div>

      <hr className="separator" />

      {/* Video 8 */}
      <div className="video-section">
        <h2 className="video-title">
        Supera i Momenti Bui con Saggezza e Serenità
        </h2>

        <div className="iframe-container">
          <iframe
            src="https://www.youtube.com/embed/OaZK0lLlK0I"
            title="YouTube video player"
            allowFullScreen
          ></iframe>
        </div>

        <div className="button-container">
          <a
            href="https://www.youtube.com/@FrequenzediSaggezzaStoica"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-icon youtube"
          >
            <i className="fab fa-youtube"></i>
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61571814955253"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-icon facebook"
          >
            <i className="fab fa-facebook"></i>
          </a>
          <a
            href="https://www.tiktok.com/@frequenze.di.sagg?_t=ZG-8t0SyheQS9p&_r=1"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-icon tiktok"
          >
            <i className="fab fa-tiktok"></i>
          </a>
        </div>

        <p className="description">
        Benvenuto su Frequenze di Saggezza Stoica, il tuo rifugio di calma e ispirazione. 
        In questo video ti guiderò attraverso una selezione di citazioni profonde e senza tempo, 
        pensate per aiutarti a superare momenti di tristezza, sconforto o difficoltà. Ogni frase 
        è un faro di speranza, un invito a riflettere e a riscoprire il potere che risiede dentro di te.
        </p>
      </div>

      <hr className="separator" />

      {/* Video 9 */}
      <div className="video-section">
        <h2 className="video-title">
        Focus Su Di Te: Come Raggiungere La Tua Migliore Versione Con Questa Guida Personale
        </h2>

        <div className="iframe-container">
          <iframe
            src="https://www.youtube.com/embed/_tjwOGEXhEk"
            title="YouTube video player"
            allowFullScreen
          ></iframe>
        </div>

        <div className="button-container">
          <a
            href="https://www.youtube.com/@FrequenzediSaggezzaStoica"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-icon youtube"
          >
            <i className="fab fa-youtube"></i>
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61571814955253"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-icon facebook"
          >
            <i className="fab fa-facebook"></i>
          </a>
          <a
            href="https://www.tiktok.com/@frequenze.di.sagg?_t=ZG-8t0SyheQS9p&_r=1"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-icon tiktok"
          >
            <i className="fab fa-tiktok"></i>
          </a>
        </div>

        <p className="description">
        Concentrati su Te Stesso: La Guida al Tuo Miglioramento Personale
        Hai mai sentito la necessità di ritrovare te stesso in un mondo che 
        ti trascina in mille direzioni diverse? “Concentrati su Te Stesso” è 
        un audiolibro progettato per aiutarti a prendere il controllo della tua vita, 
        sviluppare una disciplina interiore più solida e coltivare l’autostima necessaria 
        per superare le sfide di ogni giorno. Attraverso strategie pratiche e ispirazioni 
        provenienti dalla filosofia stoica, dall’autoconsapevolezza e dall’intelligenza emotiva, 
        questa guida ti mostrerà come dedicarti alla tua crescita personale senza perdere di vista la serenità e l’equilibrio.
        </p>
      </div>
    </div>
  );
}

export default VideoPage;